import React, { useEffect } from 'react';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarHeader,
} from "./components/ui/sidebar";

export function AppSidebar({
    markerType,
    setMarkerType,
    markerStream,
    setMarkerStream,
    tafelbeugelsAmount,
    setTafelbeugelsAmount,
    setAddMarkerMode,
    setViewMode
}) {
    // Auto-select stroom "peuken" and disable others when markerType is "peukenpiramide"
        // Auto-select stroom "peuken" and disable others when markerType is "peukenpiramide";
    // If markerType is "wapper", clear stroom selection
    useEffect(() => {
        if (markerType === 'peukenpiramide' && markerStream !== 'peuken') {
            setMarkerStream('peuken');
        } else if (markerType === 'wapper' && markerStream !== null) {
            setMarkerStream(null);
        }
    }, [markerType, markerStream, setMarkerStream]);

    return (
        <Sidebar variant="sidebar" collapsible="offcanvas" className="bg-[#484848] text-white">
            <SidebarHeader className="p-6 pb-0">
                <h2 className="">Double click on map to place marker</h2>
            </SidebarHeader>
            <SidebarContent className="p-4 space-y-6 border-width-0">
                <SidebarGroup>
<SidebarGroupLabel className="text-[#888] mb-2 px-0">Marker Type</SidebarGroupLabel>
<SidebarGroupContent className="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto">
                        {[
                            { value: 'kliko', label: 'Kliko' },
                            { value: '1100', label: '1100' },
                            { value: 'afval eiland', label: 'Afval Eiland' },
                            { value: 'afval halte', label: 'Afval Halte' },
                            { value: 'houten bak', label: 'Houten Bak' },
                            { value: 'harnas', label: 'Harnas' },
                            { value: 'tafelbeugels', label: 'Tafelbeugels' },
                            { value: 'peukenpiramide', label: 'Peukenpiramide' },
                            { value: 'wapper', label: 'Wapper' },
                        ].map((type) => (
                            <button
                                key={type.value}
                                onClick={() => setMarkerType(type.value)}
                                className={`w-full text-left px-3 py-2 rounded-md transition-all duration-200 ${markerType === type.value
                                    ? 'bg-blue-600 text-white font-semibold shadow-sm'
                                    : 'bg-[#222] text-[#aaa] hover:bg-[#2a2a2a] hover:text-white'
                                    }`}
                            >
                                {type.label}
                            </button>
                        ))}
                    </SidebarGroupContent>
                </SidebarGroup>

                <SidebarGroup>
                    <SidebarGroupLabel className="text-[#888] mb-2 px-0">Stroom</SidebarGroupLabel>
                    <SidebarGroupContent className="grid grid-cols-2 gap-2">
                        {[
                            { value: 'pmd', label: 'PMD', color: '#007bff' },
                            { value: 'waste', label: 'Restafval', color: '#222' },
                            { value: 'papier', label: 'Papier', color: 'orange' },
                            { value: 'glass', label: 'Glas', color: 'red' },
                            { value: 'gft', label: 'GFT', color: 'green' },
                            { value: 'folie', label: 'Folie', color: 'gold' },
                            { value: 'colson', label: 'Colson', color: 'gray' },
                            { value: 'peuken', label: 'Peuken', color: 'black' },
                        ].map((stream) => {
                            const isPeukenPiramide = markerType === 'peukenpiramide';
const isWapper = markerType === 'wapper';
const isDisabled =
    isWapper ||
    (markerType === 'afval eiland' || markerType === 'afval halte' || markerType === 'tafelbeugels') ||
    (isPeukenPiramide && stream.value !== 'peuken');
                            return (
                                <button
                                    key={stream.value}
                                    disabled={isDisabled}
                                    onClick={() => setMarkerStream(stream.value)}
                                    className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-200 text-sm ${(markerStream && markerStream.toLowerCase().includes(stream.value.toLowerCase()))
                                        ? 'bg-blue-600 text-white font-semibold shadow-sm'
                                        : 'bg-[#222] text-[#aaa] hover:bg-[#2a2a2a] hover:text-white'
                                        } ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                >
                                    <span
                                        className="w-3 h-3 rounded-full shrink-0 border border-[#555]"
                                        style={{ backgroundColor: stream.color }}
                                    />
                                    <span className="truncate">{stream.label}</span>
                                </button>
                            );
                        })}
                    </SidebarGroupContent>
                </SidebarGroup>

                {markerType === 'tafelbeugels' && (
                    <SidebarGroup>
                        <SidebarGroupLabel className="text-[#888] mb-2 px-0">Aantal tafelbeugels</SidebarGroupLabel>
                        <SidebarGroupContent>
                            <input
                                type="number"
                                min={1}
                                value={tafelbeugelsAmount || ''}
                                onChange={e => setTafelbeugelsAmount(Number(e.target.value))}
                                className="w-full p-2 bg-[#222] text-white border border-[#444] rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                        </SidebarGroupContent>
                    </SidebarGroup>
                )}
            </SidebarContent>
            <SidebarFooter className="p-4 mt-auto">
                <button
                    onClick={() => { setAddMarkerMode(false); setViewMode(true); }}
                    className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-md transition-colors"
                >
                    I'm done
                </button>
            </SidebarFooter>
        </Sidebar>
    );
}
